import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getPostPageEnabled } from '@wix/communities-blog-client-common';
import InternalLinkOld from './internal-link.old';
import InternalLinkNew from './internal-link.new';
import { getConfig } from '../../services/config';
import { isPreview } from '../../selectors/view-mode-selectors';

const InternalLink = ({ isPostPageEnabled, isPreview, ...props }) => {
  const { postPageSectionUrl } = getConfig();
  const Component = isPostPageEnabled && (postPageSectionUrl || isPreview) ? InternalLinkNew : InternalLinkOld;
  return <Component {...props} />;
};

InternalLink.propTypes = {
  isPostPageEnabled: PropTypes.bool.isRequired,
  isPreview: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isPostPageEnabled: getPostPageEnabled(state),
  isPreview: isPreview(state),
});

export default connect(mapStateToProps)(InternalLink);
